export const LOCAL_ZINDEX = {
  HEADER: 4,
  MAP: 1,
  MAP_CONTROLS: 2,
  MAP_OVERLAY: 3,
  PANEL: 2,
}

export const GRID_AREA_ID = 'layer'
